import { useCallback } from 'react';

import { onContextMenuButtonClicked } from '../../../common/utils/events/context-menu-button-clicked';
import { getExtensionData } from '../../../common/utils/relay/get-extension-data';
import { useAnalytics, useCommonAndPrivateAttributes } from '../../analytics';
import type { SharedEventAttributes } from '../../analytics/prepared-result-attributes';
import type { AnalyticsEventCallbacks } from '../../analytics/result-analytics-callbacks';
/**
 * @returns a callback to fire an event when the result
 * is clicked by the user.
 */

export const useFireContextMenuButtonClickedWithAttributes = (
	sharedEventAttributes: SharedEventAttributes,
	eventCallbacks: AnalyticsEventCallbacks,
): (() => void) => {
	const { commonAttributes, nonPrivacySafeAttributes } = sharedEventAttributes;
	const { fireAnalyticsEvent } = eventCallbacks;
	return useCallback(() => {
		fireAnalyticsEvent(
			onContextMenuButtonClicked({
				commonAttributes: {
					...commonAttributes,
					...getExtensionData(commonAttributes.isCQL),
				},
				nonPrivacySafeAttributes,
			}),
		);
	}, [fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes]);
};

export const useFireContextMenuButtonClicked = (): (() => void) => {
	const sharedEventAttributes = useCommonAndPrivateAttributes();
	const { fireAnalyticsEvent } = useAnalytics();
	return useFireContextMenuButtonClickedWithAttributes(sharedEventAttributes, {
		fireAnalyticsEvent,
	});
};
